import { appEnv } from '@/lib/env';

interface ApiEnvelope<T> {
  ok?: boolean;
  data?: T;
  error?: string;
  message?: string;
}

function buildApiUrl(path: string) {
  const normalizedBase = appEnv.apiBaseUrl.replace(/\/$/, '');
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${normalizedBase}${normalizedPath}`;
}

export async function apiRequest<T>(path: string, options: globalThis.RequestInit = {}): Promise<T> {
  const headers = new Headers(options.headers || {});
  const hasBody = options.body !== undefined && options.body !== null;

  if (hasBody && !headers.has('Content-Type') && !(options.body instanceof FormData)) {
    headers.set('Content-Type', 'application/json');
  }

  const response = await fetch(buildApiUrl(path), {
    credentials: 'include',
    ...options,
    headers,
  });

  const contentType = response.headers.get('content-type') || '';
  const payload = contentType.includes('application/json')
    ? ((await response.json()) as ApiEnvelope<T>)
    : null;

  if (!response.ok || payload?.ok === false) {
    throw new Error(
      payload?.error ||
      payload?.message ||
      `Request failed with status ${response.status}.`,
    );
  }

  return (payload?.data ?? null) as T;
}

export function apiGet<T>(path: string) {
  return apiRequest<T>(path);
}

export function apiSend<T>(
  path: string,
  method: 'POST' | 'PUT' | 'PATCH' | 'DELETE',
  body?: unknown,
) {
  return apiRequest<T>(path, {
    method,
    body: body === undefined ? undefined : JSON.stringify(body),
  });
}

export function apiSendFormData<T>(path: string, method: 'POST' | 'PUT' | 'PATCH', body: FormData) {
  return apiRequest<T>(path, {
    method,
    body,
  });
}

export function getBackendConfigError() {
  return '';
}

export const backendAvailable = true;
